/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

let lastScrollTop = 0;
const navbar = document.querySelector('.wp-block-klx-navigation-navbar');

if (navbar) {
    const header = navbar.closest('header');
    if (header) {
        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            // Only trigger the hide/show behavior if we've scrolled past 100px
            if (currentScroll > 100) {
                if (currentScroll > lastScrollTop) {
                    // Scrolling down - add delay before hiding
                    header.style.transform = 'translateY(-100%)';
                    header.style.transition = 'transform 0.2s ease-out';
                } else {
                    // Scrolling up - show immediately
                    header.style.transform = 'translateY(0)';
                    header.style.transition = 'transform 0.2s ease-out';
                }
            } else {
                // Reset position when scrolled less than threshold
                header.style.transform = 'translateY(0)';
            }
            
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        }, { passive: true });
    }
}

const menuMobileTrigger = document.querySelector('#klx-navigation__menu-mobile-trigger');
const mobileNav = document.querySelector('.klx-navigation__menu-mobile');
if (menuMobileTrigger && mobileNav) {
    menuMobileTrigger.addEventListener('click', () => {
        const relSrc = menuMobileTrigger.getAttribute('rel-src');
        const src = menuMobileTrigger.getAttribute('src');
        menuMobileTrigger.setAttribute('src', relSrc);
        menuMobileTrigger.setAttribute('rel-src', src);
        mobileNav.classList.toggle('active');
    });
}

// Handle mobile submenu toggles
const mobileSubmenuLinks = document.querySelectorAll('.klx-navigation__menu-mobile .has-submenu');
mobileSubmenuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all other submenus
        mobileSubmenuLinks.forEach(otherLink => {
            if (otherLink !== link) {
                otherLink.parentElement.querySelector('.klx-submenu-content')?.classList.remove('active');
                window.anime({
                    targets: otherLink.parentElement.querySelector('.klx-submenu-content'),
                    height: 0,
                    easing: 'easeInOutSine', 
                    duration: 300
                });
            }
        });

        // Toggle active class on clicked submenu
        const submenuContent = link.parentElement.querySelector('.klx-submenu-content');
        if (submenuContent) {
            submenuContent.classList.toggle('active');
            window.anime({
                targets: submenuContent,
                height: submenuContent.classList.contains('active') ? [0, submenuContent.scrollHeight] : [submenuContent.scrollHeight, 0],
                easing: 'easeInOutSine',
                duration: 300,
            });
        }
    });
});

const desktopSubmenuLinks = document.querySelectorAll('.klx-navigation__menu .has-submenu');
desktopSubmenuLinks.forEach(link => {
    link.addEventListener('mouseover', () => {
        const submenuContent = link.parentElement.querySelector('.klx-submenu-content');
        if (submenuContent) {
            window.anime({
                targets: submenuContent,
                opacity: [0, 1],
                easing: 'easeInOutSine',
                duration: 250
            });
        }
    });
});